import styled from 'styled-components';

export const InterviewFormWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const FormContentWrapper = styled.div`
  display: flex;
  & > div {
    margin-right: 48px;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;

  & > div:last-child {
    margin-left: 16px;
    margin-top: 10px;
    cursor: pointer;
  }
`;
